import React, { useContext, useReducer } from "react";

const answerContext = React.createContext();

const initialState = {
  answers: [],
  //just for text matching test to count attempt
  textMatchAttempt: 0,
  isLoading: false, // apply on processAudio api and addTestResult api
  isAudioErr: false, // apply on processAudio api and addTestResult api
};
const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_ANSWER": {
      return { ...state, answers: [...state.answers, action.payload] };
    }

    case "TEXT_MATCHING_ATTEMPT": {
      return { ...state, textMatchAttempt: action.payload };
    }

    case "PROCESSED_AUDIO": {
      console.log("processAudio", action.payload);
      const data = {
        answer: action.payload.answer,
        que_score: action.payload.que_score,
        test_format: action.payload.data,
        file_path: action.payload.file_path,
        json_res: !!action.payload.json_res ? action.payload.json_res : "",
        que_id: action.que_id,
        file_encoded: "",
        file_type: "audio",
        que_time: action.que_time,
        section_name: action.section_name,
      };
      return {
        ...state,
        answers: [...state.answers, data],
        isLoading: false,
        isAudioErr: false,
      };
    }
    case "IS_LOADING": {
      return { ...state, isLoading: action.payload };
    }
    case "IS_ERR": {
      return { ...state, isLoading: false, isAudioErr: true };
    }

    case "RESET_ANSWER": {
      return initialState;
    }

    default:
      return state;
  }
};

export function AnswerProvider(props) {
  const [answerC, dispatchAnswer] = useReducer(reducer, initialState);
  return (
    <answerContext.Provider value={{ answerC, dispatchAnswer }} {...props} />
  );
}

export function AnswerContext() {
  const context = useContext(answerContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
